/** Output options shared by the export form and deterministic renderer. */
export const VIDEO_RESOLUTIONS = {
  '480p': { width: 854, height: 480 },
  '720p': { width: 1280, height: 720 },
  '1080p': { width: 1920, height: 1080 },
} as const
export const VIDEO_FRAME_RATES = [15, 24, 30, 60] as const
export interface VideoOptions {
  resolution: keyof typeof VIDEO_RESOLUTIONS
  fps: typeof VIDEO_FRAME_RATES[number]
  subtitles: boolean
  opening: boolean
  transitions: boolean
  ending: boolean
  low_distraction: boolean
}
// 30 FPS by default: sprite sheets animate at ~12 FPS, so 60 mostly doubles the
// export time for smoother camera moves and transitions (still selectable).
export const DEFAULT_VIDEO_OPTIONS: Readonly<VideoOptions> = {
  resolution: '720p', fps: 30, subtitles: true, opening: true, transitions: true, ending: true, low_distraction: false,
}

export function videoOptions(input: Partial<VideoOptions> = {}): VideoOptions {
  const options = { ...DEFAULT_VIDEO_OPTIONS, ...input }
  if (!Object.hasOwn(VIDEO_RESOLUTIONS, options.resolution) || !VIDEO_FRAME_RATES.includes(options.fps)) {
    throw new Error('Unsupported video resolution or frame rate.')
  }
  for (const name of ['subtitles', 'opening', 'transitions', 'ending', 'low_distraction'] as const) {
    if (typeof options[name] !== 'boolean') throw new Error(`Invalid video option: ${name}.`)
  }
  return options
}
